import React from "react";
import {
  Loader,
  Breadcrumb,
  Container,
  Header,
  Grid,
  Menu,
  Segment,
} from "semantic-ui-react";
import { Link } from "react-router-dom";
import { translate } from "react-i18next";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import * as ROUTES from "../../routes";
import ExtendedComponent from "./ExtendedComponent";
import queryString from "query-string";

class PaymentStateView extends ExtendedComponent {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      loading: true,
    };
    this.TransactionService = props.services.feathers.service(
      "api/localtransactions"
    );
  }

  static mapDispatchToProps(dispatch) {
    return {
      dispatch,
      navigate: (path) => dispatch(push(path)),
    };
  }

  componentDidMount() {
    const { location } = this.props;
    const searchParams = queryString.parse(location.search);
    console.log(searchParams);
    this.fetchTransaction(Number(searchParams["external_reference"]));
  }

  fetchTransaction = (transactionId) => {
    console.log("FETCHING TRANSACTION WITH ID", transactionId);
    this.TransactionService.get(transactionId)
      .then((result) => {
        console.log("RESULT", result);
        if (result.state === "created" || result.state === "pending") {
          window.setTimeout(() => {
            this.fetchTransaction(transactionId);
          }, 3000);
        } else {
          if (result.state === "payed") {
            this.setState({
              loading: false,
              error: false,
            });
            this.props.navigate(ROUTES.BALANCE);
          } else if (result.state === "failed") {
            this.setState({
              loading: false,
              error: true,
            });
          }
        }
      })
      .catch((error) => {
        this.setState({
          error: true,
          loading: false,
        });
      });
  };

  render() {
    // eslint-disable-next-line
    const { t, location } = this.props;
    const searchParams = queryString.parse(location.search);

    return (
      <Container>
        <Menu
          inverted
          style={{ backgroundColor: "#136444", borderRadius: 0, margin: 0 }}
        >
          <Menu.Item as={Link} name="inicio" active={false} to="/dashboard" />
          <Menu.Item
            as={Link}
            name="mis reservas"
            active={false}
            to="/reservations"
          />
          <Menu.Item name="mi saldo" active={true} />
        </Menu>

        <Segment vertical secondary style={{ padding: 4 }}>
          <Breadcrumb>
            <Breadcrumb.Section as={Link} link to={"/dashboard"}>
              Inicio
            </Breadcrumb.Section>
            <Breadcrumb.Divider icon="right angle" />
            <Breadcrumb.Section active>Balance</Breadcrumb.Section>
          </Breadcrumb>
        </Segment>

        <Segment vertical>
          <Header as="h3">
            <Header.Content>
              {true
                ? `Verificando Transacción...`
                : `Tuvimos un problema verificando tu pago.`}

              <Header.Subheader>
                Puedes cerrar esta ventana, cuando se verifique tu pago lo verás
                en tu saldo.
              </Header.Subheader>
              <Loader active={true} />
            </Header.Content>
          </Header>
        </Segment>

        <Segment vertical>
          <Grid columns={2}>
            <Grid.Column></Grid.Column>
            <Grid.Column>
              <Grid centered columns={2}>
                <Grid.Column></Grid.Column>
              </Grid>
            </Grid.Column>
          </Grid>
        </Segment>
      </Container>
    );
  }
}

const i18nEnhancement = translate("translations")(PaymentStateView);
export default connect(
  PaymentStateView.mapStateToProps,
  PaymentStateView.mapDispatchToProps
)(i18nEnhancement);



// WEBPACK FOOTER //
// ./src/components/views/PaymentStateView.jsx